import { render, staticRenderFns } from "./users-profile.vue?vue&type=template&id=66c7c71e&"
import script from "./users-profile.js?vue&type=script&lang=js&"
export * from "./users-profile.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports